import { render } from "./ExtraPrices.vue?vue&type=template&id=4856584f&scoped=true&lang=pug"
import script from "./ExtraPrices.vue?vue&type=script&lang=js"
export * from "./ExtraPrices.vue?vue&type=script&lang=js"

import "./ExtraPrices.vue?vue&type=style&index=0&id=4856584f&lang=scss&scoped=true"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4856584f"]])

export default __exports__